import { MetaDefinition } from '@angular/platform-browser';

/** `noindex` only — page is not indexed but its links may still be crawled. */
export const ROBOTS_NO_INDEX: MetaDefinition = {
  name: 'robots',
  content: 'noindex'
};

/** Page is indexable and its links crawlable — the default public state. */
export const ROBOTS_INDEX_FOLLOW: MetaDefinition = {
  name: 'robots',
  content: 'index, follow'
};

/** Neither indexed nor followed — for private/conversion surfaces (stronger than ROBOTS_NO_INDEX). */
export const ROBOTS_NOINDEX_NOFOLLOW: MetaDefinition = {
  name: 'robots',
  content: 'noindex, nofollow'
};
